'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroIconTabs = require('./NitroIconTabs');

var _NitroIconTabs2 = _interopRequireDefault(_NitroIconTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroIconTabs2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon-tabs/index.js
// module id = 764
// module chunks = 4